import { render, staticRenderFns } from "./ResumoCompraMobileEvento.vue?vue&type=template&id=ecaeadf0&scoped=true"
import script from "./ResumoCompraMobileEvento.vue?vue&type=script&lang=js"
export * from "./ResumoCompraMobileEvento.vue?vue&type=script&lang=js"
import style0 from "./ResumoCompraMobileEvento.vue?vue&type=style&index=0&id=ecaeadf0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecaeadf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1708/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecaeadf0')) {
      api.createRecord('ecaeadf0', component.options)
    } else {
      api.reload('ecaeadf0', component.options)
    }
    module.hot.accept("./ResumoCompraMobileEvento.vue?vue&type=template&id=ecaeadf0&scoped=true", function () {
      api.rerender('ecaeadf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/components-evento/ResumoCompraMobileEvento.vue"
export default component.exports